import React from 'react';
import PropTypes from 'prop-types';

const renderTitle = (block, text) => <h2 className={`${block}__package-title`}>{text}</h2>;

const PackageTitle = ({ block, text, url }) => {
  if (!text) return null;

  return (
    <React.Fragment>
      {
        url
          ? <a href={url}>{renderTitle(block, text)}</a>
          : renderTitle(block, text)
      }
    </React.Fragment>
  );
};

PackageTitle.propTypes = {
  block: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string,
};

PackageTitle.defaultProps = {
  block: null,
  text: null,
  url: null,
};

export default PackageTitle;
